module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customersFound":"{count} found","customer":"Customer","allCustomers":"All customers"},"no":{"customersFound":"{count} treff","customer":"Kunde","allCustomers":"Alle kunder"}}')
  delete Component.options._Ctor
}
